import React from "react";
import { Grid, TextField, Typography, Button } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

const ServiceTypeFormModal = ({
  open,
  isEditing,
  serviceType,
  onClose,
  onInputChange,
  onFileChange,
  onSubmit,
}) => {
  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      title={isEditing ? "Edit Service Type" : "Add Service Type"}
      subtitle="Service Type"
      maxWidth={900}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Manage multilingual service type names, descriptions, and hero imagery.
        </Typography>
      }
      actions={
        <>
          <CancelButton onClick={onClose} />
          <MDButton
            type="submit"
            form="service-type-form"
            variant="gradient"
            color="info"
            sx={{ minWidth: 140 }}
          >
            {isEditing ? "Update" : "Add"}
          </MDButton>
        </>
      }
    >
      <form id="service-type-form" onSubmit={onSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (EN)"
              name="name_en"
              value={serviceType.name_en}
              onChange={onInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title (FR)"
              name="name_fr"
              value={serviceType.name_fr}
              onChange={onInputChange}
              margin="normal"
              required
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (EN)"
              name="description_en"
              value={serviceType.description_en}
              onChange={onInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Description (FR)"
              name="description_fr"
              value={serviceType.description_fr}
              onChange={onInputChange}
              margin="normal"
              multiline
              rows={3}
              InputProps={{ sx: { borderRadius: 2 } }}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <input
                type="file"
                id="service-type-image"
                onChange={(e) => onFileChange(e, "image")}
                style={{ display: "none" }}
              />
              <label htmlFor="service-type-image">
                <Button variant="outlined" component="span" sx={{ width: "100%", color: "gray" }}>
                  Upload Image
                </Button>
              </label>
              {serviceType.image_preview && (
                <img
                  src={serviceType.image_preview}
                  alt="Preview"
                  style={{ width: "100px", height: "auto", borderRadius: 8, border: "1px solid #e5e7eb" }}
                />
              )}
            </div>
          </Grid>
        </Grid>
      </form>
    </ModalLayout>
  );
};

export default ServiceTypeFormModal;
